import createClient from "openapi-fetch";
import type { paths } from "../../__definitions__/slack-admin.changeengine.com-definitions";
import { serviceURL } from "../../utils/service-url";

export const slackAdmin = createClient<paths>({
  baseUrl: serviceURL("slack-admin"),
  headers: {
    "Content-Type": "application/json",
  },
});
